import React from 'react';
import { Users, Target } from 'lucide-react';

const CompetitorAnalysisPanel = ({ keywords }) => {
  const competitorData = [
    {
      name: 'Concurrent A',
      domain: 'concurrent-a.com',
      commonKeywords: keywords?.filter(k => k?.difficulty === 'hard')?.length || 0,
      avgPosition: 8.5,
      estimatedTraffic: 2500
    },
    {
      name: 'Concurrent B',
      domain: 'concurrent-b.com',
      commonKeywords: keywords?.filter(k => k?.difficulty === 'medium')?.length || 0,
      avgPosition: 12.3,
      estimatedTraffic: 1800
    },
    {
      name: 'Concurrent C',
      domain: 'concurrent-c.com',
      commonKeywords: keywords?.filter(k => k?.difficulty === 'easy')?.length || 0,
      avgPosition: 15.7,
      estimatedTraffic: 1200
    }
  ];

  return (
    <div className="space-y-6">
      {/* Competitor Overview */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <Users className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Analyse concurrentielle</h3>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Concurrent</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Domaine</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Mots-clés communs</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Position moy.</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Trafic estimé</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {competitorData?.map((competitor, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-900 font-medium">{competitor?.name}</td>
                  <td className="px-4 py-3 text-sm text-blue-600">{competitor?.domain}</td>
                  <td className="px-4 py-3 text-sm text-gray-900">{competitor?.commonKeywords}</td>
                  <td className="px-4 py-3 text-sm text-gray-900">#{competitor?.avgPosition}</td>
                  <td className="px-4 py-3 text-sm text-gray-600">{competitor?.estimatedTraffic?.toLocaleString()}/mois</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Content Gaps */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <Target className="w-6 h-6 text-green-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Opportunités de contenu</h3>
        </div>

        <div className="space-y-3">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2">Mots-clés à cibler</h4>
            <p className="text-sm text-blue-800 mb-2">
              Identifiez les mots-clés pour lesquels vos concurrents se positionnent bien mais pas vous.
            </p>
            <div className="flex flex-wrap gap-2">
              {keywords?.filter(k => !k?.current_ranking && k?.search_volume > 300)?.slice(0, 5)?.map((keyword) => (
                <span key={keyword?.id} className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
                  {keyword?.keyword} ({keyword?.search_volume})
                </span>
              ))}
            </div>
          </div>

          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h4 className="font-semibold text-green-900 mb-2">Points forts</h4>
            <p className="text-sm text-green-800 mb-2">
              Mots-clés où vous êtes mieux positionné que vos concurrents.
            </p>
            <div className="flex flex-wrap gap-2">
              {keywords?.filter(k => k?.current_ranking && k?.current_ranking <= 10)?.slice(0, 5)?.map((keyword) => (
                <span key={keyword?.id} className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                  {keyword?.keyword} (#{keyword?.current_ranking})
                </span>
              ))}
            </div>
          </div>

          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <h4 className="font-semibold text-orange-900 mb-2">À améliorer</h4>
            <p className="text-sm text-orange-800 mb-2">
              Mots-clés où vous pourriez gagner des positions face à la concurrence.
            </p>
            <div className="flex flex-wrap gap-2">
              {keywords?.filter(k => k?.current_ranking && k?.current_ranking > 10 && k?.current_ranking <= 20)?.slice(0, 5)?.map((keyword) => (
                <span key={keyword?.id} className="px-3 py-1 bg-orange-100 text-orange-800 text-sm rounded-full">
                  {keyword?.keyword} (#{keyword?.current_ranking})
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompetitorAnalysisPanel;